import AlertWorkOrderFormWrapper from "./AlertWorkOrderFormWrapper";
import AlertWorkOrderForm from "./AlertWorkOrderForm";

export default AlertWorkOrderFormWrapper(AlertWorkOrderForm);
